import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludeRejected'
})
export class ExcludeRejectedPipe implements PipeTransform {
  transform(handleOperations: any[]): any[] {
    return handleOperations ? handleOperations.filter(
      handleOperation => handleOperation.status !== 'REJECTED'
    ) : [];
  }
}